/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createNode } from '../../factoriesAny.js';
export var NodeDependencies = {
  createNode: createNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNode.generated.js
// module id = 56
// module chunks = 0